// Copyright (c) 2020 Deere & Company

import RgaSearch from '../../rga/search';

export default {
    component: RgaSearch,
    name: 'Part Request Search',
    path: 'search'
};




// WEBPACK FOOTER //
// ./src/routes/rga/search.js